/*  @flow */
import * as React from 'react';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import ActionButton from 'components/ActionsList/components/ActionButton/ActionButton';

import { updateEditLocation } from 'permissions/account';

const actionsListData: any = [
  {
    label: 'general:actions.edit_location',
    icon: '#icon-edit',
    class: '',
    action: 'edit',
    type: 'link',
    permissions: updateEditLocation,
    condition(data: Object, action: Object, callback: Function): React.Node {
      return (
        data && (
          <ActionButton
            to={{
              pathname: `/accounts/${data.accountId}/location/${data.locationId}/edit`,
              state: {
                details: data.details,
                locationDetails: data.locationDetails ? data.locationDetails : {},
                titleEnd: data.titleEnd,
                accountId: data.accountId,
                locationId: data.locationId,
              },
            }}
            data={data}
            action={action}
          />
        )
      );
    },
  },
  {
    label: 'general:actions.archive_location_plural',
    icon: '#icon-archive',
    action: 'archiveLocationsByCompany',
    type: 'drawer',
    permissions: updateEditLocation,
    condition(data: Object, action: Object, callback: Function): React.Node {
      const hasLocations = data.details.locations_count.length > 0;

      return hasLocations && <ActionButton data={data} action={action} onActionDrawer={callback} />;
    },
  },
];

export default actionsListData;
